var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDownloadMobile = function SvgDownloadMobile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1991_10570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1673 11.0026C20.1673 15.3238 20.1673 17.4844 18.8244 18.8264C17.4833 20.1693 15.3218 20.1693 11.0007 20.1693C6.67948 20.1693 4.5189 20.1693 3.17598 18.8264C1.83398 17.4853 1.83398 15.3238 1.83398 11.0026C1.83398 6.68144 1.83398 4.52085 3.17598 3.17794C4.51982 1.83594 6.67948 1.83594 11.0007 1.83594",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83398 11.4595L3.43998 10.0543C3.84253 9.70235 4.36375 9.51651 4.89815 9.53438C5.43254 9.55225 5.94019 9.7725 6.31832 10.1505L10.2508 14.083C10.556 14.3881 10.959 14.5758 11.3889 14.613C11.8188 14.6503 12.2481 14.5346 12.6012 14.2865L12.8752 14.094C13.3845 13.7363 14.0001 13.562 14.6213 13.5994C15.2425 13.6369 15.8327 13.884 16.2953 14.3003L19.2507 16.9595",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9.25V1M15.75 9.25L13 6.5M15.75 9.25L18.5 6.5",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1991_10570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "download-mobile.d0d864fafc86de6ca0c153f5237b0502.svg";